import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { PhaseItem } from "../../../../pages/hid-admin/dashboard/partner-settings/technology-management/types";
import type { TechnologySettingsPhasesState } from "./Types";

const initialState: TechnologySettingsPhasesState = {
  phases: [],
  status: {
    phasesLoading: false,
    createPhaseLoading: false,
    updatePhaseLoading: false,
    createActivityLoading: false,
    updateActivityLoading: false,
    reorderPhasesLoading: false,
    deletePhaseLoading: false,
    deleteActivityLoading: false,
  },
};

const technologySettingsPhasesSlice = createSlice({
  name: "technology-settings-phases",
  initialState,
  reducers: {
    setPhases: (state, action: PayloadAction<PhaseItem[]>) => {
      state.phases = action.payload;
    },
    setPhasesLoading: (state, action: PayloadAction<boolean>) => {
      state.status.phasesLoading = action.payload;
    },
    setCreatePhaseLoading: (state, action: PayloadAction<boolean>) => {
      state.status.createPhaseLoading = action.payload;
    },
    setUpdatePhaseLoading: (state, action: PayloadAction<boolean>) => {
      state.status.updatePhaseLoading = action.payload;
    },
    setCreateActivityLoading: (state, action: PayloadAction<boolean>) => {
      state.status.createActivityLoading = action.payload;
    },
    setUpdateActivityLoading: (state, action: PayloadAction<boolean>) => {
      state.status.updateActivityLoading = action.payload;
    },
    setReorderPhasesLoading: (state, action: PayloadAction<boolean>) => {
      state.status.reorderPhasesLoading = action.payload;
    },
    setDeletePhaseLoading: (state, action: PayloadAction<boolean>) => {
      state.status.deletePhaseLoading = action.payload;
    },
    setDeleteActivityLoading: (state, action: PayloadAction<boolean>) => {
      state.status.deleteActivityLoading = action.payload;
    },
  },
});

export const technologySettingsPhasesSliceReducer =
  technologySettingsPhasesSlice.reducer;
export const technologySettingsPhasesSliceAction =
  technologySettingsPhasesSlice.actions;
